export default __webpack_public_path__ + "static/media/q27_v2.e60b0fbc.png";